export const SHOEBOX_ATTACHMENTS_INCLUDE =
  'attachment.file:embed,file.variants:embed,attachment.owner:embed,bill.integrationStatus:embed'
